import styled from 'styled-components';

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const FooterRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 30px;
    border-top: 1px solid #444;
    background-color: #222;
`;

export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: "#fff";
    }
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    height: 30px;
    min-height: 30px;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &.special {
        min-width: 200px;
        width: 200px;
        height: 30px;
        min-height: 30px;
    }

    &:last-child{
        margin-right: 0;
    }
`;

export const ConfirmMessage = styled.div`
    font-size: 14px;
    margin-right: 20px;
    color: #fff;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    padding: 0 50px 50px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${p => p.align ?? 'flex-start'};
    justify-content: flex-start;

    &.hasLink:hover {
        background-color:#555;
        cursor: pointer;
    }
`;

export const Column = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const Image = styled.div`
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    height: 100px;
    min-height: 100px;
    max-height: 100px;
    background-color: #000;
    position: relative;
    margin-bottom: 30px;
`;

export const Name = styled.div`
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    margin-bottom: 30px;
`;

export const Label = styled.div`
    font-size: 14px;
    color: #999;
    width: 120px;
    min-width: 120px;
    margin-bottom: 10px;

    &.large {
        width: 150px;
        min-width: 150px;
    }
`;

export const Value = styled.div`
    flex: 1;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
`;

export const ValueOff = styled(Value)`
    color: #888;
`;

export const TagGroup = styled.div`
    margin-top: 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    & ${Label} {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
    }
`;

export const Tag = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 7px;
    height: 35px;
    margin-right: 5px;
    margin-bottom: 10px;
    border-width: 3px;
    border-style: solid;
    border-radius: 17px;
    color: #fff;
    font-size: 14px;
    border-color: #fff;

    &.content {
        border-color: #26f;
    }

    &.tools {
        border-color: #cc0;
    }
`;

export const PlayerIcon = styled.div`
    width: 30px;
    height: 30px;
    background-color: ${p => p.color ?? '#fff'};
    color: ${p => p.fgColor ?? '#000'};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0 5px 5px;
`;

export const PlayerName = styled.div`
    margin-left: 10px;
    color: #fff;
    font-size: 14px;
`;

export const PlayerNameOff = styled(PlayerName)`
    color: #888;
`;

export const PlayerGMIcon = styled(PlayerName)`
    width: 30px;
    height: 30px;
    margin-left: 0px;
    position: relative;

    &:before {
        content: '\\F01A5';
        font-family: 'Material Design Icons';
        font-size: 18px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFAB2E;
    }
`;
